"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesGetAsyncSlice = void 0;
const name_1 = require("./name.js");
const _api_1 = require("../../api/index.js");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
const xuder_1 = require("@sonar-software/xuder");
exports.coreInitiativesGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    defaultRequest: {
        assignedTos: [],
        count: 20,
        key: '',
        paginationDirection: sonar_ts_types_1.PaginationDirection.Forward,
        sortBy: 'createdOn',
        sortDirection: 'descending',
        statuses: [],
        title: ''
    },
    name: name_1.CoreInitiativesName,
    receive: true,
    request: true,
    requestHandler: _api_1.getInitiatives,
    retainDataOnRequest: true,
    yieldType: xuder_1.SagaYieldType.Latest
});
//# sourceMappingURL=get.js.map